import { Link } from "react-router-dom";
import { ArrowRight, BookOpen, ChevronDown } from "lucide-react";
import rules from "@/data/rules.json";
import "./HomeRules.css";

export default function RulesPreview() {
    return <section className="wx-container wx-rules-preview" data-testid="rules-preview" aria-labelledby="rules-preview-heading">
        <div className="wx-rules-preview-card">
            <details><summary className="wx-rules-preview-heading"><BookOpen size={20} aria-hidden="true" /><h2 id="rules-preview-heading">Rules WxFaous</h2><ChevronDown size={18} aria-hidden="true" /></summary>
            <p className="wx-rules-preview-lead">Baca dulu sebelum order ya Ci.</p>
            <h3 className="wx-rules-preview-deadline-title">{rules.deadline.title}</h3>
            <div className="wx-rules-preview-limits"><span>China <strong>30 hari</strong></span><span>Bangkok <strong>14 hari</strong></span></div>
            <p>{rules.deadline.explanation}</p>
            <p className="wx-rules-preview-warning">{rules.deadline.warning}</p>
            </details>
            <Link to="/rules" className="wx-rules-link">Baca Rules Lengkap <ArrowRight size={17} aria-hidden="true" /></Link>
        </div>
    </section>;
}
